import React from "react";
import "../styles/ElementalStyles.css";
import { usePageInitialization } from "../hooks/usePageInitialization";

// Import Home2 section components
import {
  HeroSection,
  RelevanceSection,
  ServicesSection,
  ProcessSection,
  NotUsSection
} from "../components/sections/home2";
import Header from "../components/sections/Header";
import HeadMeta from "../components/sections/HeadMeta";
import Footer from "../components/sections/Footer";
import Subvencio from "../components/sections/Subvencio";
import CookieConsent from "../components/common/CookieConsent";

const HomePage2 = () => {
  usePageInitialization("Elemental Value", {
    handleSplash: false,
    initSwiper: false
  });

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Elemental Value",
      legalName: "EV23 FINANCE, S.L.",
      url: "https://elementalvalue.co",
      logo: "https://elementalvalue.co/img/logo.svg",
      email: "info@elementalvalue.co",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Calle Diputació, 238, 5ª, 1ª",
        postalCode: "08007",
        addressLocality: "Barcelona",
        addressCountry: "ES",
      },
      sameAs: ["https://www.linkedin.com/company/elementalvalue-co/"],
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Elemental Value",
      url: "https://elementalvalue.co",
    },
  ];

  return (
    <>
      <HeadMeta
        title="Elemental Value — CFO externo y dirección financiera estratégica"
        description="Orden financiero y criterio estratégico para CEOs y fundadores. Servicios de CFO externo, reporting y análisis para tomar mejores decisiones."
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <Header />
      <main>
        <HeroSection />
        <RelevanceSection />
        <ServicesSection />
        <ProcessSection />
        <NotUsSection />
      </main>
      <Footer />
      <Subvencio />
      <CookieConsent />
    </>
  );
};

export default HomePage2;
